import {Asset, SearchResult} from "../../interface/Server";

export interface AssetFilter {
    price?: {
        min: number,
        max: number,
    }
    code?: string
    area?: '林地' | '海濱' | '城市森林' | '果園',
    type?: string,
}

export interface State {
    assets?: Array<Asset>,
    assetGroups?: { [technicalName: string]: Array<Asset> },
    filter?: AssetFilter,
    searchResults?: Array<SearchResult>,
    showDonors?: boolean,
}

export const state: State = {
    assets: [],
    assetGroups: {},
    searchResults: [],
    showDonors: false,
};
export default state;

